import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export function RequireHeartVerified({ children }) {
  const tempHeart = useSelector((state) => state.heart.tempHeart);
  const isVerified = useSelector((state) => state.heart.isVerified);

  if (!tempHeart?.id) {
    // No heart started—go back to /add-heart
    return <Navigate to="/add-heart" replace />;
  }

  if (!isVerified) {
    // Not yet verified—go to /add-heart/verify
    return <Navigate to="/add-heart/verify" replace />;
  }

  // All checks passed, render the protected content
  return children;
}